import {DocumentoRelacionadoFE} from '../../../../interfaces/factura-exportacion.interface'

export const LONGITUD_MAXIMA_NUMERO_DOCUMENTO_RELACIONADO = 36

export const MAXIMO_DOCUMENTOS_RELACIONADOS = 50

export const TIPO_GENERACION_FISICO = 1

export const TIPO_GENERACION_ELECTRONICO = 2

export const TIPOS_GENERACION_DOCUMENTO_RELACIONADO = [
  {codigo: `${TIPO_GENERACION_FISICO}`, valor: 'Físico'},
  {codigo: `${TIPO_GENERACION_ELECTRONICO}`, valor: 'Electrónico'},
]

export const TIPOS_DTE_RELACIONADO_EXPORTACION = ['01', '03', '04', '05', '06', '11']

export const nombreTipoGeneracion = (tipoGeneracion: any): string =>
  TIPOS_GENERACION_DOCUMENTO_RELACIONADO.find((tipo) => tipo.codigo === `${tipoGeneracion ?? ''}`)
    ?.valor ?? ''

export const camposDocumentoRelacionadoDelEsquema = (documento: DocumentoRelacionadoFE) => ({
  tipoDocumento: `${documento?.tipoDocumento ?? ''}`.trim(),
  tipoGeneracion: Number(documento?.tipoGeneracion),
  numeroDocumento: `${documento?.numeroDocumento ?? ''}`
    .trim()
    .substring(0, LONGITUD_MAXIMA_NUMERO_DOCUMENTO_RELACIONADO),
  fechaEmision: `${documento?.fechaEmision ?? ''}`.trim().split(' ')[0],
  tipoDocRelDesc: `${documento?.tipoDocumentoDescripcion ?? ''}`.trim(),
})

export const documentoRelacionadoCompleto = (documento: DocumentoRelacionadoFE): boolean => {
  const campos = camposDocumentoRelacionadoDelEsquema(documento)
  return (
    campos.tipoDocumento !== '' &&
    campos.numeroDocumento !== '' &&
    campos.fechaEmision !== '' &&
    Number.isFinite(campos.tipoGeneracion) &&
    campos.tipoGeneracion > 0
  )
}

export const camposDocumentoRelacionadoExportacion = (
  esNormativaDos: boolean,
  documentos: Array<DocumentoRelacionadoFE>
) => {
  if (!esNormativaDos) return {}

  const relacionados = (documentos ?? [])
    .filter(documentoRelacionadoCompleto)
    .slice(0, MAXIMO_DOCUMENTOS_RELACIONADOS)
    .map(camposDocumentoRelacionadoDelEsquema)

  return relacionados.length > 0 ? {docRelacionado: relacionados} : {}
}
